import { useState } from 'react';
import { Info, X } from 'lucide-react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import SbImg from './strut_brace.jpg';

export default function DesignDisclaimer() {
  const [show, setShow] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  if (!show) return null;

  return (
    <>
      <div className="absolute top-4 left-1/2 -translate-x-1/2 z-20 w-full max-w-xl px-4">
        <div className="flex items-start gap-3 rounded-xl bg-brand-dark/80 backdrop-blur-md px-4 py-3 text-white/90 shadow-xl ring-1 ring-white/10">
          <span className="size-5 shrink-0 mt-0.5 rounded-full bg-brand-red flex items-center justify-center">
            <Info className="text-white text-[10px]" />
          </span>
          <p className="m-0 text-sm leading-relaxed">
            This viewer is intended for design representation purposes only and should be
            interpreted accordingly. Please note that{' '}
            <a
              href="#/"
              onClick={(e) => {
                e.preventDefault();
                setModalOpen(true);
              }}
              className="underline decoration-white/30 underline-offset-2 hover:decoration-white/60 transition-colors text-white font-medium"
            >
              bracing
            </a>{' '}
            is not displayed.
          </p>
          <button
            onClick={() => setShow(false)}
            className="shrink-0 rounded-lg p-1 text-white/50 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"
            aria-label="Dismiss"
          >
            <X className="size-4" />
          </button>
        </div>
      </div>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <DialogPanel className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden">
            <div className="flex items-center justify-between px-6 py-4 bg-gray-50">
              <DialogTitle className="text-lg font-semibold text-brand-dark m-0">
                Bracing
              </DialogTitle>
              <button
                onClick={() => setModalOpen(false)}
                className="rounded-lg p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors cursor-pointer"
                aria-label="Close"
              >
                <X className="size-5" />
              </button>
            </div>
            <div className="px-6 py-5">
              <p className="text-gray-600 leading-relaxed mb-4">
                Some form of bracing will be required on a mezzanine floor, generally strut or cross
                braces. This 3D viewer does not currently show bracing. To discuss how this affects
                the final design, click the &lsquo;Contact Us&rsquo; button to speak to our sales
                team.
              </p>
              <figure className="m-0">
                <img src={SbImg} alt="Bracing example" className="w-full rounded-lg" />
                <figcaption className="text-xs text-gray-400 mt-2">
                  Example of strut bracing on a mezzanine floor
                </figcaption>
              </figure>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
